import { useState, useEffect, useContext, useRef } from 'react';
import { Container, Grid, Box, Typography, Button, Paper, Chip } from '@mui/material';
import React from 'react';
import { AuthContext } from "../../context/authContext";
import { useNavigate, useLocation } from 'react-router-dom';
import sinfoto from './assets/sinfoto.gif';
import { getCarritoByID, deleteCarritoByID, updateCarritoByID, buyCarritoByID } from "../../services/CarritoServices";
import { getDataFiscal } from "../../services/ClientesServices";
import { getProvincias } from "../../services/ProvinciaServices";
import { getLocalidades } from "../../services/LocalidadesServices";
import SeccionCarrito from "./SeccionCarrito";
import SeccionDatosCliente from './SeccionDatosCliente';
import SeccionEnvios from "./SeccionEnvios";
import SeccionPago from './SeccionPago';
import SeccionResumenTotal from './SeccionResumenTotal';
import SeccionObservacionGeneral from './SeccionObservacionGeneral';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import StoreIcon from '@mui/icons-material/Store';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const StepIndicator = ({ steps, activeStep }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: { xs: 0.5, sm: 1 }, mb: 3, flexWrap: 'wrap' }}>
    {steps.map((step, i) => {
      const isActive = activeStep === step.value;
      const isDone = activeStep > step.value;
      return (
        <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.5, sm: 1 } }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, px: { xs: 1, sm: 1.5 }, py: 0.5, borderRadius: 'var(--radius-full)', backgroundColor: isActive ? 'var(--accent)' : isDone ? 'var(--success)' : 'var(--bg-subtle)', border: '1.5px solid ' + (isActive ? 'var(--accent)' : isDone ? 'var(--success)' : 'var(--border)'), transition: 'all 0.25s ease' }}>
            {isDone ? <CheckCircleOutlineIcon sx={{ fontSize: 16, color: '#fff' }} /> : React.cloneElement(step.icon, { sx: { fontSize: 16, color: isActive ? '#fff' : 'var(--text-muted)' } })}
            <Typography sx={{ fontFamily: 'var(--font-body)', fontSize: '0.7rem', fontWeight: isActive ? 700 : 500, color: isActive || isDone ? '#fff' : 'var(--text-muted)', display: { xs: isActive ? 'block' : 'none', sm: 'block' } }}>{step.label}</Typography>
          </Box>
          {i < steps.length - 1 && <Box sx={{ width: { xs: 12, sm: 24 }, height: 2, backgroundColor: isDone ? 'var(--success)' : 'var(--border)', borderRadius: 'var(--radius-full)' }} />}
        </Box>
      );
    })}
  </Box>
);

const StepSummary = ({ icon, label, value, extra }) => (
  <Paper elevation={0} sx={{ border: '1px solid var(--border)', borderRadius: 'var(--radius-md)', backgroundColor: 'var(--bg-card)', mb: 1.5 }}>
    <Box sx={{ px: 2, py: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {icon}
        <Typography sx={{ fontFamily: 'var(--font-heading)', fontWeight: 700, fontSize: '0.85rem', color: 'var(--text-primary)' }}>{label}</Typography>
        {value && <Chip label={value} size="small" sx={{ fontFamily: 'var(--font-body)', fontWeight: 600, fontSize: '0.7rem', backgroundColor: 'var(--bg-subtle)', color: 'var(--text-secondary)', border: '1px solid var(--border)' }} />}
      </Box>
      {extra}
    </Box>
  </Paper>
);

const Cart = () => {
  const { setIdCarrito, empresa, addToCart, user } = useContext(AuthContext);
  const [provinciaOptions, setProvinciaOptions] = useState([]);
  const [localidadOptions, setLocalidadOptions] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({});
  const [paymentMethod, setPaymentMethod] = useState("local");
  const [shippingMethod, setShippingMethod] = useState();
  const [shipping, setShipping] = useState({});
  const [isLogin, setIsLogin] = useState(localStorage.getItem('user'));
  const [loading, setLoading] = useState(false);
  const [montoMinimo, setMontoMinimo] = useState();
  const [retiroLocal, setRetiroLocal] = useState(false);
  const [entregaSucursal, setEntregaSucursal] = useState(false);
  const [envioTransporte, setEnvioTransporte] = useState(false);
  const [envioAndreani, setEnvioAndreani] = useState(false);
  const [pagoEnTienda, setPagoEnTienda] = useState(false);
  const [pagoEnTransferencia, setPagoEnTransferencia] = useState(false);
  const [pagoEnEcommerce, setPagoEnEcommerce] = useState(false);
  const [paymentConfirmed, setPaymentConfirmed] = useState(false);
  const [cartList, setCartList] = useState([]);
  const [descuento, setDescuento] = useState(null);
  const [descuentoAplicado, setDescuentoAplicado] = useState(null);
  const [totalGeneral, setTotalGeneral] = useState(null);
  const [totalFinal, setTotalFinal] = useState(null);
  const [obsEntregaSucursal, setObsEntregaSucursal] = useState(null);
  const [obsEnvioTransporte, setObsEnvioTransporte] = useState(null);
  const [obsGeneral, setObsGeneral] = useState(null);
  const [carritoID, setCarritoID] = useState(null);
  const [errors, setErrors] = useState({});
  const carritoRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const pasoCarritoRef = useRef(null);
  const pasoEnvioRef = useRef(null);
  const pasoPagoRef = useRef(null);
  const pasoResumenRef = useRef(null);

  const stepsDef = [
    { value: 0, label: 'Carrito', icon: <ShoppingBagOutlinedIcon /> },
    { value: 2, label: 'Envío', icon: <LocalShippingOutlinedIcon /> },
    { value: 3, label: 'Pago', icon: <PaymentOutlinedIcon /> },
    { value: 4, label: 'Resumen', icon: <ReceiptLongOutlinedIcon /> },
  ];
  const shippingLabels = { local: "Retiro del Local", sucursal: "Entrega en Sucursal", transporte: "Envío por Encomienda", andreani: "Envío por Andreani", domicilio: "Envío a Domicilio" };

  useEffect(() => { const o = { behavior: "smooth", block: "start" }; if (activeStep === 0) pasoCarritoRef.current?.scrollIntoView(o); if (activeStep === 2) pasoEnvioRef.current?.scrollIntoView(o); if (activeStep === 3) pasoPagoRef.current?.scrollIntoView(o); if (activeStep === 4) pasoResumenRef.current?.scrollIntoView(o); }, [activeStep]);
  useEffect(() => { if (empresa) { setMontoMinimo(Number(empresa.monto_minimo)); setRetiroLocal(empresa.retiro_local); setEntregaSucursal(empresa.entrega_sucursal); setEnvioTransporte(empresa.envio_transporte); setEnvioAndreani(empresa.envio_andreani); setPagoEnTienda(empresa.pagoLocalActivo); setPagoEnTransferencia(empresa.pagoTransferenciaActivo); setPagoEnEcommerce(empresa.mercadoPagoActivo); } }, [cartList, empresa]);
  useEffect(() => { fetchProvincia(); fetchCarrito(); }, []);
  useEffect(() => { if (formData?.provincia?.id) { getLocalidades(formData.provincia.id).then(r => setLocalidadOptions(r)).catch(console.error); } else { setLocalidadOptions([]); } }, [formData?.provincia]);

  const fetchCarrito = async () => {
    const id = localStorage.getItem('idCarrito');
    setCarritoID(id);
    if (id) {
      try {
        await getCarrito(id);
      }
      catch (e) {
        console.error(e);
      }
    }
  };
  const fetchProvincia = async () => { try { setProvinciaOptions(await getProvincias()); } catch (e) { console.error(e); } };
  const handleChange = (e) => { const { name, value } = e.target; setFormData(p => ({ ...p, [name]: value })); };
  const handlePaymentMethodChange = (e) => setPaymentMethod(e.target.value);
  const handleShippingMethodChange = (e) => setShippingMethod(e.target.value);

  const obtenerDatosEnvio = () => {
    if (!shippingMethod) return null;
    const method = shippingMethod.toLowerCase().trim();

    switch (method) {
      case "transporte":
        return { metodo: "transporte", datos: { ...obsEnvioTransporte } };
      case "sucursal":
        return { metodo: "sucursal", datos: { ...obsEntregaSucursal } };
      case "local":
        return { metodo: "local", descripcion: "Retira en el local" };
      case "andreani":
        return { metodo: "andreani", descripcion: "Envío por Andreani" };
      default:
        return { metodo: method };
    }
  };

  const obtenerDatosPago = () => {
    if (!paymentMethod) return null;
    return { metodo: paymentMethod, fecha: new Date().toISOString() };
  };

  const armarObservacionLegible = () => {
    const lineas = [];

    // Observación general
    if (obsGeneral?.trim()) {
      lineas.push(`${obsGeneral.trim()}`);
    }

    // Envío
    switch (shippingMethod?.toLowerCase().trim()) {
      case "local":
        lineas.push("Entrega: Retira en el local");
        break;

      case "andreani":
        lineas.push("Entrega: Envío por Andreani");
        break;

      case "sucursal":
        if (obsEntregaSucursal) {
          lineas.push(
            `Entrega: Sucursal ${obsEntregaSucursal.nombre ?? ""}`
          );

          if (obsEntregaSucursal.direccion) {
            lineas.push(`${obsEntregaSucursal.direccion}`);
          }
        }
        break;

      case "transporte":
        if (obsEnvioTransporte) {
          lineas.push("Entrega: Envío por transporte");

          const direccion = [
            obsEnvioTransporte.calle,
            obsEnvioTransporte.nro,
            obsEnvioTransporte.piso && `Piso ${obsEnvioTransporte.piso}`,
            obsEnvioTransporte.dpto && `Dpto ${obsEnvioTransporte.dpto}`,
          ]
            .filter(Boolean)
            .join(" ");

          if (direccion) lineas.push(`📍 ${direccion}`);

          const localidad = [
            obsEnvioTransporte.localidad,
            obsEnvioTransporte.provincia,
          ]
            .filter(Boolean)
            .join(", ");

          if (localidad) lineas.push(`${localidad}`);

          if (obsEnvioTransporte.cp) {
            lineas.push(`📮 Código Postal: ${obsEnvioTransporte.cp}`);
          }

          if (obsEnvioTransporte.observacion?.trim()) {
            lineas.push(
              `${obsEnvioTransporte.observacion.trim()}`
            );
          }
        }
        break;
    }

    // Pago
    const pagos = {
      local: "Pago: En el local",
      transferencia: "Pago: Transferencia bancaria",
      "mercado-pago": "Pago: Mercado Pago",
    };

    if (paymentMethod) {
      lineas.push(pagos[paymentMethod] ?? `Pago: ${paymentMethod}`);
    }

    return lineas.join("\n");
  };

  const handleBuyCart = async () => {
    setLoading(true);

    try {
      if (!isLogin && !validateForm()) return;

      const idUser = user.empleadoUser?.length > 0
        ? user.empleadoUser[0].id
        : user.id;

      const dataf = await getDataFiscal(idUser);

      if (!dataf) {
        navigate("/account", { state: { from: location.pathname } });
        return;
      }

      const idCarrito = localStorage.getItem("idCarrito");

      const clienteData = {
        ...formData,
        observacion: armarObservacionLegible()
      };

      const esMercadoPago = paymentMethod === "mercado-pago";

      const res = await buyCarritoByID({
        car_id: Number(idCarrito),
        mercadoPago: esMercadoPago,
        oca_fp:
          paymentMethod === "local" ? 0
            : paymentMethod === "transferencia" ? 1
              : 2,
        oca_state:
          paymentMethod === "local" ? 0
            : paymentMethod === "transferencia" ? 1
              : 0,
        cliente: JSON.stringify(clienteData),
      });

      if (esMercadoPago) {
        window.location.href = res.data.link;
      } else {
        localStorage.removeItem("idCarrito");
        setIdCarrito(null);
        navigate("/orderok");
      }
    } catch (error) {
      console.error(error?.response?.data?.error);

      if (error?.response?.data?.error === "No hay stock suficiente.") {
        await fetchCarrito();
        setActiveStep(0);
        setTimeout(() => {
          carritoRef?.current?.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    } finally {
      setLoading(false);
    }
  };
  const validateForm = () => { let e = {}; Object.keys(formData).forEach(k => { if (!formData[k]) e[k] = "Obligatorio"; }); setErrors(e); return !Object.keys(e).length; };

  const getCarrito = async (id) => {
    var res = await getCarritoByID(id);
    if (res) {
      setCartList(res?.Carrito_items?.map(item => ({ id: item?.id, title: item?.descripcion, codigo: item?.codigo, price: item?.precio, priceShow: item?.precio?.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), urls: [item?.item_art?.art_imagen ? process.env.REACT_APP_URL_BACKEND + item.item_art.art_imagen : sinfoto], amount: item?.cantidad, availableStock: item?.stock_real, observation: item?.observacion , fractional: item?.item_art?.art_fraccionable ===1 ? true : false })));
      console.log("res",res)
      const tcd = res.monto_total_desc, tsd = res.monto_total;
      setTotalFinal(tcd > 0 ? tcd : tsd); setTotalGeneral(res.monto_total);
      if (res.descuento) { setDescuento({ descripcion: res.descuento.desc_descripcion, porcentaje: res.descuento.desc_porcentaje, fechaFin: res.descuento.desc_fecha_fin, monto_minimo: res.descuento.monto_minimo }); setDescuentoAplicado(res.monto_total - res.monto_total_desc); } else { setDescuento(null); }
    }
  };

  const deleteFromCart = async (id) => { await deleteCarritoByID(id); await getCarrito(carritoID); setCartList(p => p.filter(i => i.id !== id)); };
  const formatToCurrency = (a) => a?.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const changeAmount = async (amount, artid) => { await Promise.all(cartList.map(async item => { if (item.id === artid) { await updateCarritoByID(artid, { cantidad: Math.max(1, item.amount + amount) }); } return item; })); await getCarrito(carritoID); };
  const subTotal = (s = "formatted") => { const t = cartList.reduce((a, i) => a + i.price * i.amount, 0); return s === "formatted" ? formatToCurrency(t) : t; };

  if (cartList.length === 0) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', textAlign: 'center', maxWidth: 420, mx: 'auto', px: 3, py: 6, animation: 'fadeInUp 0.4s ease both' }}>
        <Box sx={{ width: 72, height: 72, borderRadius: 'var(--radius-xl)', backgroundColor: 'var(--bg-subtle)', display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}><ShoppingBagOutlinedIcon sx={{ fontSize: 36, color: 'var(--text-muted)' }} /></Box>
        <Typography sx={{ fontFamily: 'var(--font-heading)', fontWeight: 800, fontSize: '1.3rem', color: 'var(--text-primary)', mb: 0.5 }}>Tu carrito está vacío</Typography>
        <Typography sx={{ fontFamily: 'var(--font-body)', fontSize: '0.9rem', color: 'var(--text-muted)', mb: 3 }}>¿Por qué no explorás nuestros artículos?</Typography>
        <Button variant="contained" onClick={() => navigate("/category")} sx={{ borderRadius: 'var(--radius-md)', fontFamily: 'var(--font-heading)', fontWeight: 700, fontSize: '0.9rem', textTransform: 'none', backgroundColor: 'var(--accent)', px: 4, py: 1.25, boxShadow: '0 4px 12px rgba(233,69,96,0.3)', '&:hover': { backgroundColor: 'var(--accent-hover)', transform: 'translateY(-1px)' } }}>Ver productos</Button>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 'var(--container-max)', mx: { xs: 1, md: 12 }, px: { xs: 2, md: 3 }, py: { xs: 2, md: 3 }, animation: 'fadeInUp 0.4s ease both' }}>
      <StepIndicator steps={stepsDef} activeStep={activeStep} />

      {activeStep === 0 ? (
        <Box ref={pasoCarritoRef}><SeccionCarrito isActive isCheckStock={!empresa?.venta_sin_stock} onNext={() => setActiveStep(2)} cartList={cartList} changeAmount={changeAmount} deleteFromCart={deleteFromCart} formatToCurrency={formatToCurrency} descuento={descuento} descuentoAplicado={descuentoAplicado} totalGeneral={totalGeneral} totalFinal={totalFinal} montoMinimo={montoMinimo} /></Box>
      ) : (
        <StepSummary icon={<ShoppingCartCheckoutIcon sx={{ color: 'var(--accent)', fontSize: 20 }} />} label="Carrito" value={`${cartList.length} art.`} extra={<Typography sx={{ fontFamily: 'var(--font-heading)', fontWeight: 700, fontSize: '0.9rem', color: 'var(--text-primary)' }}>${formatToCurrency(totalFinal)}</Typography>} />
      )}

      {activeStep === 2 ? (
        <Box ref={pasoEnvioRef}><SeccionEnvios onBack={() => setActiveStep(0)} onNext={() => setActiveStep(3)} retiroLocal={retiroLocal} entregaSucursal={entregaSucursal} envioTransporte={envioTransporte} envioAndreani={envioAndreani} obsEntregaSucursal={obsEntregaSucursal} setObsEntregaSucursal={setObsEntregaSucursal} obsEnvioTransporte={obsEnvioTransporte} setObsEnvioTransporte={setObsEnvioTransporte} loading={loading} subTotal={subTotal} shipping={shipping} setShipping={setShipping} formatToCurrency={formatToCurrency} shippingMethod={shippingMethod} handleShippingMethodChange={handleShippingMethodChange} /></Box>
      ) : (
        <StepSummary icon={shippingMethod ? <LocalShippingOutlinedIcon sx={{ color: 'var(--success)', fontSize: 20 }} /> : <HelpOutlineIcon sx={{ color: 'var(--text-muted)', fontSize: 20 }} />} label="Envío" value={shippingMethod ? shippingLabels[shippingMethod] : null} extra={shipping?.precioTotal ? <Typography sx={{ fontFamily: 'var(--font-mono)', fontWeight: 600, fontSize: '0.82rem', color: 'var(--text-secondary)' }}>{new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(shipping.precioTotal)}</Typography> : null} />
      )}

      {activeStep === 3 && !paymentConfirmed ? (
        <Box ref={pasoPagoRef}><SeccionPago onBack={() => setActiveStep(2)} onNext={() => setActiveStep(4)} pagoEnEcommerce={pagoEnEcommerce} pagoEnTransferencia={pagoEnTransferencia} pagoEnTienda={pagoEnTienda} loading={loading} subTotal={subTotal} paymentMethod={paymentMethod} handlePaymentMethodChange={handlePaymentMethodChange} /></Box>
      ) : (
        <StepSummary icon={paymentMethod === 'local' ? <StoreIcon sx={{ color: 'var(--info)', fontSize: 20 }} /> : paymentMethod === 'transferencia' ? <AccountBalanceWalletIcon sx={{ color: 'var(--purple)', fontSize: 20 }} /> : <HelpOutlineIcon sx={{ color: 'var(--text-muted)', fontSize: 20 }} />} label="Pago" value={paymentMethod === 'local' ? 'Pago en el Local' : paymentMethod === 'transferencia' ? 'Transferencia' : null} />
      )}

      {activeStep <= 4 && (
        <>
          {user.rol_id === 1 && (
            <SeccionObservacionGeneral
              observacion={obsGeneral}
              onSave={(obs) => setObsGeneral(obs)}
            />
          )
          }
          <Box ref={pasoResumenRef} sx={{ mt: 1 }}>
            <SeccionResumenTotal
              subTotal={subTotal()}
              onBack={() => setActiveStep(3)}
              shipping={shipping}
              formatToCurrency={formatToCurrency}
              handleBuyCart={handleBuyCart}
              descuento={descuento}
              descuentoAplicado={descuentoAplicado}
              totalGeneral={totalGeneral}
              totalFinal={totalFinal}
              loading={loading}
              isComplete={activeStep === 4}
            />
          </Box>

        </>
      )}


    </Box>
  );
};

export default Cart;